import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Row, Col, Typography } from 'antd';
import { LinkOutlined, SearchOutlined, ThunderboltFilled, HistoryOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SearchBar = ({ url, keyword, onUrlChange, onKeywordChange, onAnalyze, onHistoryClick, loading }) => {
    const [localUrl, setLocalUrl] = useState(url);
    const [localKeyword, setLocalKeyword] = useState(keyword);

    useEffect(() => { setLocalUrl(url); }, [url]);
    useEffect(() => { setLocalKeyword(keyword); }, [keyword]);

    const handleAnalyze = () => {
        onUrlChange(localUrl);
        onKeywordChange(localKeyword);
        onAnalyze(localUrl, localKeyword);
    };

    return (
        <Card
            size="small"
            style={{ marginBottom: 12, borderRadius: 8, background: '#ffffff' }}
            bodyStyle={{ padding: '10px 16px' }}
        >
            <Row gutter={[8, 8]} align="bottom">
                <Col flex="1">
                    <div style={{ marginBottom: 3 }}>
                        <Text style={{ fontSize: 12 }}><LinkOutlined style={{ marginRight: 4 }} />상품 주소 (URL)</Text>
                    </div>
                    <Input
                        placeholder="네이버 쇼핑 상품 주소를 입력하세요"
                        value={localUrl}
                        onChange={e => setLocalUrl(e.target.value)}
                        onBlur={() => onUrlChange(localUrl)}
                        onPressEnter={handleAnalyze}
                        allowClear
                        style={{ fontSize: 12 }}
                    />
                </Col>
                <Col style={{ width: 220 }}>
                    <div style={{ marginBottom: 3 }}>
                        <Text style={{ fontSize: 12 }}><SearchOutlined style={{ marginRight: 4 }} />메인 키워드</Text>
                    </div>
                    <Input
                        placeholder="메인/대표키워드"
                        value={localKeyword}
                        onChange={e => setLocalKeyword(e.target.value)}
                        onBlur={() => onKeywordChange(localKeyword)}
                        onPressEnter={handleAnalyze}
                        allowClear
                        style={{ fontSize: 12 }}
                    />
                </Col>
                <Col>
                    <Button
                        type="primary"
                        icon={<ThunderboltFilled />}
                        onClick={handleAnalyze}
                        loading={loading}
                        style={{
                            background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                            border: 'none',
                            fontWeight: 700,
                            boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)',
                        }}
                    >
                        분석 시작
                    </Button>
                </Col>
                <Col>
                    <Button
                        icon={<HistoryOutlined />}
                        disabled={loading}
                        onClick={onHistoryClick}
                    >
                        조회기록
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

export default SearchBar;
